import React from 'react';
// styles
import styled from 'styled-components';

const TimeIcon = ({ className, ...props }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
    aria-label="Time"
    className={className}
  >
    <g clipPath="url(#clip0_520_1339)">
      <path
        d="M16 6C14.0222 6 12.0888 6.58649 10.4443 7.6853C8.79981 8.78412 7.51809 10.3459 6.76121 12.1732C6.00433 14.0004 5.8063 16.0111 6.19215 17.9509C6.578 19.8907 7.53041 21.6725 8.92894 23.0711C10.3275 24.4696 12.1093 25.422 14.0491 25.8079C15.9889 26.1937 17.9996 25.9957 19.8268 25.2388C21.6541 24.4819 23.2159 23.2002 24.3147 21.5557C25.4135 19.9112 26 17.9778 26 16C25.9971 13.3487 24.9426 10.8068 23.0679 8.9321C21.1932 7.05736 18.6513 6.00287 16 6ZM20.3333 20.3508C20.1822 20.5107 19.9748 20.6056 19.7551 20.6152C19.5353 20.6248 19.3204 20.5486 19.1558 20.4025L15.0233 16.6142C14.9376 16.5364 14.8691 16.4416 14.822 16.3359C14.7749 16.2301 14.7504 16.1157 14.75 16V11.4167C14.75 11.1957 14.8378 10.9837 14.9941 10.8274C15.1504 10.6711 15.3623 10.5833 15.5833 10.5833C15.8044 10.5833 16.0163 10.6711 16.1726 10.8274C16.3289 10.9837 16.4167 11.1957 16.4167 11.4167V15.6333L20.2783 19.1733C20.3594 19.247 20.4252 19.336 20.4718 19.4351C20.5185 19.5343 20.5451 19.6416 20.5502 19.7511C20.5553 19.8605 20.5388 19.9699 20.5016 20.073C20.4644 20.176 20.4072 20.2699 20.3333 20.3508Z"
        fill="#94A6B8"
      />
    </g>
    <defs>
      <clipPath id="clip0_520_1339">
        <rect width="20" height="20" fill="white" transform="translate(6 6)" />
      </clipPath>
    </defs>
  </svg>
);

export default styled(TimeIcon)``;
